<div class="container-fluid">
  <app-header titleText="Export Invoices" i18n-titleText></app-header>
  <form class="row mb-3" (ngSubmit)="loadJobs()">
    <div class="col-sm-2">
      <input name="projectName" id="projectName"
             class="form-control" placeholder="Search Projects" i18n-placeholder
             [(ngModel)]="filter.projectName" #projectName="ngModel" />
    </div>
    <div class="col-sm-2">
      <select name="dateRange" id="dateRange"
              class="form-control select-bidit"
              [(ngModel)]="filter.convertedDateRange" #dateRange="ngModel">
        <option value="undefined" i18n>Select Converted Date Range</option>
        <option value="1" i18n>Current Month</option>
        <option value="2" i18n>Current Quarter</option>
        <option value="3" i18n>Current Year</option>
        <option value="4" i18n>Prior Month</option>
        <option value="5" i18n>Prior Quarter</option>
        <option value="6" i18n>Prior Year</option>
      </select>
    </div>
    <div class="col-sm-2">
      <select name="dateRange" id="dateRange"
              class="form-control select-bidit"
              [(ngModel)]="filter.startDateRange" #dateRange="ngModel">
        <option value="undefined" i18n>Select Start Date Range</option>
        <option value="1" i18n>Current Month</option>
        <option value="2" i18n>Current Quarter</option>
        <option value="3" i18n>Current Year</option>
        <option value="4" i18n>Prior Month</option>
        <option value="5" i18n>Prior Quarter</option>
        <option value="6" i18n>Prior Year</option>
      </select>
    </div>
    <div class="col-sm-2">
      <select name="salespersonId" id="salespersonId"
              class="form-control select-bidit"
              [(ngModel)]="filter.salespersonId" #salespersonId="ngModel">
        <option value="" i18n>Select Salesperson</option>
        <option *ngFor="let salesperson of salespersons" [ngValue]="salesperson.id">{{salesperson.lastName}}, {{salesperson.firstName}}</option>
      </select>
    </div>
    <div class="col-sm-2">
      <button type="submit" class="btn btn-bidit-action" onclick="this.blur();" i18n>Apply Filter</button>
    </div>
    <div class="col-sm-2">
      <button type="button" (click)="downloadInvoices()" class="mr-3 btn btn-bidit-action" i18n>Export</button>
    </div>
  </form>

  <table mat-table class="table-bidit table-striped" style="width: 100%;" [dataSource]="dataSource"
         matSort matSortActive="projectNbr" matSortDirection="desc">
    <ng-container matColumnDef="projectNbr">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Project Nbr</th>
      <td mat-cell *matCellDef="let invoice">
        {{invoice.quote_ProjectNumber}}
      </td>
    </ng-container>
    <ng-container matColumnDef="changeOrder">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Change Order</th>
      <td mat-cell *matCellDef="let invoice">
        {{invoice.revision_ID}}
      </td>
    </ng-container>
    <ng-container matColumnDef="customerName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Customer</th>
      <td mat-cell *matCellDef="let invoice">
        {{invoice.customer.customer_BusinessName}}
      </td>
    </ng-container>
    <ng-container matColumnDef="projectName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Project Name</th>
      <td mat-cell *matCellDef="let invoice">
        {{invoice.quote_Name}}
      </td>
    </ng-container>
    <ng-container matColumnDef="bidAmount">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Bid Amount</th>
      <td mat-cell *matCellDef="let invoice">
        <span *ngIf="invoice.changeOrder_ID; then changeOrder else original"></span>
        <ng-template #changeOrder>{{invoice.changeOrder_BidAmount | number: '1.2-2'}}</ng-template>
        <ng-template #original>{{invoice.quote_BidAmount | number: '1.2-2'}}</ng-template>        
      </td>
    </ng-container>
    <ng-container matColumnDef="exportDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Exported</th>
      <td mat-cell *matCellDef="let invoice">
        {{invoice.quote_InvoiceExportedDate | date:'yyyy/MM/dd'}}
      </td>
    </ng-container>
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef class="bidit-header">
        <mat-checkbox id="selectAll" name="selectAll" labelPosition="before" (change)="toggleSelectAll($event)" i18n>Select All</mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let invoice">
        <mat-checkbox class="d-flex align-items-center justify-content-center" [(ngModel)]="invoice.isSelected"></mat-checkbox>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns">
    </tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator [pageSize]="25" [pageSizeOptions]="[25]"></mat-paginator>
</div>
